import styled from 'styled-components';
import { panel } from '../panel';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f3f4f6;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 400px;
  background-color: white;
  ${panel};
  overflow: hidden;
  padding: 24px;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

export const Icon = styled.svg`
  width: 64px;
  height: 64px;
  color: #c62828;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: bold;
  color: #111827;
  text-align: center;
  margin-bottom: 8px;
`;

export const Message = styled.p`
  text-align: center;
  color: #3e4255;
  margin-bottom: 24px;
`;

export const Button = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background-color: #0b5fd9;
  color: white;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0b5fd9;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.5);
  }
`;

export const ButtonIcon = styled.svg`
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;
